export default [
    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
        path: '',
        redirect: '/',
        component: () => import('@/layouts/Main.vue'),
        children: [
            {
                path: '/',
                name: 'dashboard',
                component: () => import('@views/Dashboard.vue'),
                meta: {
                  breadcrumb: [

                    {
                      text: "Dashboard",
                      active: true
                    }
                  ],
                  title: 'Dashboard',
                  authRequired: true,
                }
            },
            {
                path: '/account',
                name: 'account',
                component: () => import('@views/account/UserEdit.vue'),
                meta: {
                   breadcrumb: [
                      {
                        text: "Dashboard",
                        to:{ path:"/"}
                      },
                      {
                        text: "Account",
                        active: true
                      }
                  ],
                  title: 'Profile',
                  authRequired: true,
                },
            },
            {
                path: '/orders',
                name: 'order',
                component: () => import('@views/orders/OrderList.vue'),
                meta: {
                  breadcrumb: [
                      {
                        text: "Dashboard",
                        to:{ path:"/"}
                      },
                      {
                        text: "Orders",
                        active: true
                      }
                  ],
                  title: "Orders List",
                  authRequired: true,
                },
            },
            {
              path: '/orders/:orderId(\\d+)',
              name: 'order-show',
              component: () => import('@views/orders/OrderShow.vue'),
              meta: {
                  breadcrumb: [
                    {
                      text: "Orders",
                      to:{ path:"/orders"}
                    },
                    {
                      text: "View order",
                      active: true
                    }
                ],
                title: "View order",
                authRequired: true,
              },
            },
            {
              path: '/earnings',
              name: 'earnings',
              component: () => import('@views/earnings/Earnings.vue'),
              meta: {
                  breadcrumb: [
                    {
                      text: "Dashboard",
                      to:{path:"/dashboard"}
                    },
                    {
                      text: "Earnings",
                      active: true
                    }
                ],
                title: 'Earnings',
                authRequired: true,
              },
            },
            {
              path: '/notifications',
              name: 'notifications',
              component: () => import('@views/notifications/NotificationList.vue'),
              meta: {
                  breadcrumb: [
                    {
                      text: "Dashboard",
                      to:{path:"/dashboard"}
                    },
                    {
                      text: "Notifications List",
                      active: true
                    }
                ],
                title: "Notifications",
                authRequired: true,
              }
            },
            {
              path: '/chats',
              name: 'chats',
              component: () => import('@views/chats/Chats.vue'),
              meta: {
                  breadcrumb: [
                    {
                      text: "Dashboard",
                      to:{path:"/"}
                    },
                    {
                      text: "Chats",
                      active: true
                    }
                ],
                title: "Chats",
                authRequired: true,
              }
            },
        ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
        path: '',
        component: () => import('@/layouts/FullPage.vue'),
        children: [
          {
            path: '/login',
            name: 'login',
            component: () => import('@/views/pages/Login.vue'),
            meta: {
              guestRequired: true,
              title: "Login"
            }
          },
          {
              path: '/error-404',
              name: 'error-404',
              component: () => import('@/views/pages/Error404.vue'),
              meta: {
                title: "404 - Page not Found"
              }
          },
          {
              path: '/error-500',
              name: 'error-500',
              component: () => import('@/views/pages/Error500.vue'),
              meta: {
                title: "500 - Server error"
              }
          },
        ]
    },
    // Redirect to 404 page, if no match found
    {
        path: '*',
        redirect: '/error-404'
    },

]